import { render, staticRenderFns } from "./AddressComfirm.vue?vue&type=template&id=2b4485df&"
import script from "./AddressComfirm.vue?vue&type=script&lang=js&"
export * from "./AddressComfirm.vue?vue&type=script&lang=js&"
import style0 from "./AddressComfirm.vue?vue&type=style&index=0&id=2b4485df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports